

import { Dialog, CloseButton, Button,  Text } from "@chakra-ui/react";

import { loadGeojsonTypeAsync } from "../../../../../utilies/loader/LoadGeojson";
import { useAppStore } from "../../../../../context/store";
const LayersApprovalLoadLayers = () => {
  // state
  const layersApprovalLoadLayerDialog = useAppStore((s) => s.layersApprovalLoadLayerDialog);

  // setters / refs
  const setLayersApprovalLoadLayerDialog = useAppStore.getState().setLayersApprovalLoadLayerDialog;

  return (
    <Dialog.Root modal={false} open={layersApprovalLoadLayerDialog ? true : false} closeOnInteractOutside={false}>
      <Dialog.Positioner
        // pass clicks to underlying UI except dialog box itself
        style={{ pointerEvents: "none" }} // clicks pass-through
      >
        <Dialog.Content
          // make dialog interactive again
          style={{ pointerEvents: "auto" }} // clicks captured only on box
        >
          <Dialog.Header>
            <Dialog.Title>Loading Confirmation</Dialog.Title>
          </Dialog.Header>

          <Dialog.Body>
            <Text>The input file is big and might cause the browser to crash. Do you want to proceed?</Text>
          </Dialog.Body>

          <Dialog.Footer>
            <Dialog.ActionTrigger asChild>
              <Button
                variant="outline"
                onClick={() => {
                  setLayersApprovalLoadLayerDialog(null);
                }}
              >
                Cancel
              </Button>
            </Dialog.ActionTrigger>

            <Button
              colorPalette={"red"}
              onClick={() => {
                loadGeojsonTypeAsync(layersApprovalLoadLayerDialog);
                setLayersApprovalLoadLayerDialog(null);
              }}
            >
              Load
            </Button>
          </Dialog.Footer>

          <Dialog.CloseTrigger
            asChild
            onClick={() => {
              setLayersApprovalLoadLayerDialog(null);
            }}
          >
            <CloseButton size="sm" />
          </Dialog.CloseTrigger>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
};

export default LayersApprovalLoadLayers;
